const messages = {
  fleetWithOptions:
    "Du kan ikke velge flåte hvis du har valgt alternativer",
  addProduct: "Produktet ditt er lagt til i handlekurven.",
  addProducts: "Produktene dine er lagt til i handlekurven.",
  profileSaved: "Profilopplysningene dine er lagret",
  canAddProduct: "Du har ikke nok poeng.",
  customerNumberSaved: "Kundenummer lagret",
  customerNumberExist: "Kundenummer tilgjengelig",
  complaintForm: "Forespørselen din er mottatt. Vennligst vent på svar",
  openHourSaved: "Åpningstidene er lagret",
  changeParentId:
    "Du kan ikke endre underavdelingen med høyere kundenummer hvis den har underordnede avdelinger.",
  requestSent: "Forespørselen er sendt",
  completeProfileRequired:
    "Du må fylle ut profilen din 100 % for å kunne fortsette handle i butikken.",
  accessDenied: "Tilgang nektet",
  incomplete_address: "Adressen er ufullstendig. Vennligst sjekk",
  waitMoment: "Vent et øyeblikk",
  downloadFinished: "Nedlasting fullført",
  selectOneField: "Velg ett felt",
  noVoucher: "Kupongen ble ikke funnet",
  cannotAddCsNumber: "Du kan ikke legge til kundenummer",
  messagesDeletedSuccess: "Meldingene ble slettet.",
  messagesDeletedError: "Kunne ikke slette meldinger.",
  fillProfile: "Fyll ut profilen for å kunne laste ned certifikatet.",
  favoriteAdded: "Lagt til i favoritter.",
  favoriteRemoved: "Fjernet fra favoritter.",
};

export default {
  messages,
};
